module.exports = __webpack_public_path__ + "img/nodata.0dc1e16e.svg";